import { Box, CircularProgress, styled } from '@ori-ui/mui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Root = styled(props => /*#__PURE__*/_jsx("div", {
  ...props,
  // This instructs personal menu to render here
  "data-personal-menu-outlet": true
}))({
  // Hide the placeholder loader when menu loads iin
  '& > div:not(:only-child):first-of-type': {
    display: 'none'
  },
  // This is so it fills the rest of burger menu minus height of action section switcher
  height: 'calc(100dvh - 54px)'
});
export const BurgerPersonalMenuOutlet = () => /*#__PURE__*/_jsx(Root, {
  children: /*#__PURE__*/_jsxs(Box, {
    display: "flex",
    justifyContent: "center",
    children: [/*#__PURE__*/_jsx(CircularProgress, {}), process.env.NODE_ENV === 'development' ? /*#__PURE__*/_jsx("p", {
      children: "Development detected. Please make sure that you have included personal-menu-app CAP script in your index.html with script HTML tag"
    }) : null]
  })
});